module.exports = __webpack_public_path__ + "static/media/rupessIcon.6ee36021.svg";